import { createContext } from "react";
import {
  ITrip,
  ITripResponse,
  IConfirmTripPaymentRequest,
  IConfirmTripPaymentResponse,
} from "../../models/trip/response";
import { ITripQuery } from "../../models/trip/query";
import {
  ITripRequest,
  ITripCreateRequest,
  IAddOrderToTripRequest,
  IRemoveOrderFromTripRequest,
  IExportTripFinancialReportRequest,
} from "../../models/trip/request";

export interface ITripContext {
  list: ITripResponse | null;
  details: ITrip | null;
  query: ITripQuery | null;
  loading: string[];
  actions: {
    getList: () => Promise<void>;
    getDetails: (id: number) => Promise<void>;
    create: (data: ITripCreateRequest) => Promise<boolean>;
    update: (id: number, data: ITripRequest) => Promise<boolean>;
    updateTrip: (id: number, data: ITripRequest) => Promise<boolean>;
    addOrderToTrip: (
      id: number,
      data: IAddOrderToTripRequest,
    ) => Promise<boolean>;
    removeOrderFromTrip: (
      id: number,
      data: IRemoveOrderFromTripRequest,
    ) => Promise<boolean>;
    exportExcel: (data: any) => Promise<void>;
    exportFinancialReport: (
      data: IExportTripFinancialReportRequest,
    ) => Promise<void>;
    confirmPayment: (
      id: number,
      data: IConfirmTripPaymentRequest,
    ) => Promise<IConfirmTripPaymentResponse | null>;
    setQuery: (query: ITripQuery) => void;
    reset: () => void;
  };
}

const TripContext = createContext<ITripContext>({
  list: null,
  details: null,
  query: null,
  loading: [],
  actions: {
    getList: async () => {},
    getDetails: async (id: number) => {},
    create: async (data: ITripCreateRequest) => false,
    update: async (id: number, data: ITripRequest) => false,
    updateTrip: async (id: number, data: ITripRequest) => false,
    addOrderToTrip: async (id: number, data: IAddOrderToTripRequest) => false,
    removeOrderFromTrip: async (
      id: number,
      data: IRemoveOrderFromTripRequest,
    ) => false,
    exportExcel: async (data: any) => {},
    exportFinancialReport: async (
      data: IExportTripFinancialReportRequest,
    ) => {},
    confirmPayment: async (id: number, data: IConfirmTripPaymentRequest) =>
      null,
    setQuery: (query: ITripQuery) => {},
    reset: () => {},
  },
});

export default TripContext;
